export function getMessage(value: unknown): string | undefined {
  if (typeof value === 'string') return value;

  if (typeof value === 'object' && value !== null) {
    const msg = (value as Record<string, unknown>).message;
    if (typeof msg === 'string') return msg;

    for (const nested of Object.values(value)) {
      if (
        typeof nested === 'object' &&
        nested !== null &&
        typeof (nested as Record<string, unknown>).message === 'string'
      ) {
        return (nested as Record<string, unknown>).message as string;
      }
    }
  }

  return undefined;
}
